angular.module('app').directive("fileread", [function () {
    return {
        restrict: "E",
        scope: {
            callback: "&cb",
            imgLoad: "="
        },
        link: function (scope, element, attributes) {
            var cb = !!scope.callback && scope.callback(),
                watchers = [];


            if (!!attributes.imgSrc) {
                getBlob(attributes.imgSrc);
            }

            if (!!attributes.watch) {
                watchers.push(scope.$watch("imgLoad", function (newVal) {
                    if (!!newVal) {
                        var fr = new FileReader();
                        fr.onloadend = function () {
                            !!cb && cb(fr.result);
                        };
                        fr.readAsDataURL(newVal);
                    }
                }))
            }

            function getBlob(src) {
                if (src) {
                    var x = new XMLHttpRequest();
                    x.open('GET', src);
                    x.responseType = 'blob';
                    x.onload = function () {
                        var blob = x.response;
                        var fr = new FileReader();
                        fr.onloadend = function () {
                            !!cb && cb(blob, fr.result);
                        };
                        fr.readAsDataURL(blob);
                    };
                    x.send();
                }
            }

            scope.$on("$destroy", function () {
                var i = 0;
                while (watchers[i]) {
                    watchers[i]();
                    i++
                }
            })
        }
    }
}]);